import { render, staticRenderFns } from "./Debtors.vue?vue&type=template&id=e6015bbc&scoped=true"
import script from "./Debtors.vue?vue&type=script&lang=js"
export * from "./Debtors.vue?vue&type=script&lang=js"
import style0 from "./Debtors.vue?vue&type=style&index=0&id=e6015bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6015bbc",
  null
  
)

/* custom blocks */
import block0 from "./Debtors.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports